export const utcToday = () => new Date().toISOString().slice(0, 10);
export const shiftDay = (date, days) => {
  const value = new Date(`${date}T00:00:00Z`);
  value.setUTCDate(value.getUTCDate() + days);
  return value.toISOString().slice(0, 10);
};
export const daySelection = date => ({period: 'day', start_date: date, end_date: date});
export const isRolling = selection => ['24h', '48h', '72h'].includes(selection.period);
export const selectionQuery = selection => new URLSearchParams(Object.entries(selection).filter(([, value]) => value)).toString();
export const formatDay = date => new Date(`${date}T00:00:00Z`).toLocaleDateString('en-US', {month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC'});
export const dateLabel = selection => {
  if (isRolling(selection)) return `Last ${selection.period.slice(0, -1)} hours`;
  if (selection.period === 'all') return 'All time';
  if (['7', '30'].includes(selection.period)) return `Last ${selection.period} days`;
  return selection.start_date === selection.end_date ? formatDay(selection.start_date) : `${formatDay(selection.start_date)} – ${formatDay(selection.end_date)}`;
};
export const formatBucket = (value, hourly = false, includeDate = false) => {
  const date = new Date(value.includes('T') ? value : `${value}T00:00:00Z`);
  const day = date.toLocaleDateString('en-US', {month: 'short', day: 'numeric', timeZone: 'UTC'});
  if (!hourly) return day;
  const clock = date.toLocaleTimeString('en-GB', {hour: '2-digit', minute: '2-digit', timeZone: 'UTC'});
  return includeDate ? `${day}, ${clock}` : clock;
};
export const bucketTooltip = (value, hourly = false) => hourly ? `${value.slice(0, 10)} · ${formatBucket(value, true)} UTC` : `${value} · UTC`;
export const windowLabel = selection => `${formatBucket(selection.start_at, true, true)} – ${formatBucket(selection.end_at, true, true)} UTC`;

export function dateError(start, end) {
  const valid = value => /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(Date.parse(`${value}T00:00:00Z`)) && new Date(`${value}T00:00:00Z`).toISOString().slice(0, 10) === value;
  if (!valid(start) || !valid(end)) return 'Choose a valid date for each field.';
  if (start > end) return 'Start date must be on or before end date.';
  if (end > utcToday()) return 'Dates cannot be in the future.';
  if ((Date.parse(end) - Date.parse(start)) / 86400000 + 1 > 3660) return 'Choose a date range of 3,660 days or less.';
  return '';
}

export function exportPeriod(selection) {
  if (selection.rolling_hours) return `last-${selection.rolling_hours}h_ending_${selection.end_at.replace(/\.\d+/, '').replace('+00:00', 'Z').replace(/:/g, '-')}`;
  if (selection.period === 'all') return `all-time_through_${selection.end_date}`;
  if (selection.start_date === selection.end_date) return selection.start_date;
  return `${selection.start_date}_to_${selection.end_date}`;
}

export function savedDateSelection() {
  const params = new URLSearchParams(window.location.search);
  const period = params.get('period');
  if (['24h', '48h', '72h', '7', '30'].includes(period)) return {period};
  const start = params.get('start_date');
  const end = params.get('end_date') || (period === 'day' ? start : '');
  if (['day', 'custom'].includes(period) && !dateError(start || '', end || '') && (period !== 'day' || start === end)) {
    return {period, start_date: start, end_date: end};
  }
  return {period: '24h'};
}